<div class="seq-list" cdkDropList (cdkDropListDropped)="drop($event)">
  <div class="seq-item" *ngFor="let step of order; let i = index" cdkDrag [cdkDragDisabled]="!!result"
    [class.seq-item--correct]="itemState[step.id] === 'correct'" [class.seq-item--incorrect]="itemState[step.id] === 'incorrect'">
    <span class="seq-item__idx">{{i + 1}}</span>
    <span class="seq-item__text">{{step.text}}</span>
  </div>
</div>

<div class="game-actions">
  <button type="button" class="btn btn--sm m-0" [disabled]="checking" (click)="checkOrder()" *ngIf="!result">
    Check order
  </button>
  <button type="button" class="btn btn--sm m-0" (click)="tryAgain()" *ngIf="result">Try again</button>
  <span class="game-feedback" *ngIf="result" [class.game-feedback--good]="result.allCorrect" [class.game-feedback--bad]="!result.allCorrect">
    {{result.allCorrect ? 'Correct order' : 'Not quite — check the highlighted steps'}}
  </span>
</div>
